Object.defineProperty(exports, '__esModule', { value: true });

var coreComponentsShared = require('../shared');

function getSidePanelTestIds(dataTestId) {
    return {
        modal: dataTestId,
        content: coreComponentsShared.getDataTestId(dataTestId, 'content'),
        footer: coreComponentsShared.getDataTestId(dataTestId, 'footer'),
        controls: coreComponentsShared.getDataTestId(dataTestId, 'controls'),
        header: coreComponentsShared.getDataTestId(dataTestId, 'header'),
        title: coreComponentsShared.getDataTestId(dataTestId, 'header-title'),
        closer: coreComponentsShared.getDataTestId(dataTestId, 'header-closer'),
        backButton: coreComponentsShared.getDataTestId(dataTestId, 'header-back-button'),
    };
}

exports.getSidePanelTestIds = getSidePanelTestIds;
